import PropTypes from "prop-types";
import styles from "./TicketsList.module.css";
import TicketItem from "../TicketItem";

/**
 * Interactive component. List of tickets with a header.
 */
export function TicketsList({ tickets }) {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.headerGrid}>
          <div className={styles.headerItem}>Event</div>
          <div className={styles.headerItem}>Job Code</div>
          <div className={styles.headerItem}>Ticket Name</div>
          <div className={styles.headerItem}>Ticket ID</div>
          <div className={styles.headerItem}>Purchase Date</div>
        </div>

        <div className={styles.ticketsContainer}>
          {tickets.map((ticket, index) => (
            <div
              className={
                index % 2 === 0 ? styles.backgroundWhite : styles.backgroundGray
              }
            >
              <TicketItem
                ticketInfo={{
                  event: ticket.event,
                  jobCode: ticket.jobCode,
                  name: ticket.name,
                  id: ticket.id,
                  date: ticket.date,
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

TicketsList.propTypes = {
  tickets: PropTypes.arrayOf(PropTypes.object),
};
